module.exports = __webpack_public_path__ + "static/media/doctor_male.c850db67.png";